import { c as _c } from "react/compiler-runtime";
import { useDialogs } from '@/contexts/dialogs/hooks';
import React, { useRef, useEffect } from 'react';
import { useEnvironmentContext } from './environment.provider';
import { DialogTitle, DialogFooter, DialogContent, DialogDescription } from '@/comps/primitives/dialog';
import { Button } from '@/comps/primitives/button';
import { useEnvironmentQuery } from '@/hooks/use-environment-query';
export function UpdateProvider(props) {
  const $ = _c(6);
  const env = useEnvironmentContext();
  const refOrNull = env.gitRef ?? null;
  const {
    data: newRef
  } = useEnvironmentQuery(_temp, refOrNull);
  const dialogs = useDialogs();
  const initialGitRef = useRef(refOrNull);
  let t0;
  let t1;
  if ($[0] !== dialogs || $[1] !== newRef) {
    t0 = () => {
      if (newRef !== initialGitRef.current) {
        dialogs.push({
          content: <RefreshDialog />
        });
      }
    };
    t1 = [newRef, dialogs];
    $[0] = dialogs;
    $[1] = newRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== props.children) {
    t2 = <>{props.children}</>;
    $[4] = props.children;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(env_0) {
  return env_0.GIT_REF;
}
function RefreshDialog() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DialogTitle>This page needs to be refreshed</DialogTitle>;
    t1 = <DialogDescription>A new version is available, please refresh the page to get the latest version</DialogDescription>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogContent>{t0}{t1}<DialogFooter><Button onClick={_temp2}>Refresh</Button></DialogFooter></DialogContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp2() {
  return window.location.reload();
}